import React from 'react';
import { Box, BoxProps } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Legend } from '../Legend/Legend';
import { Chart } from '../Chart/Chart';

interface CategoryScoreProps extends BoxProps {
  leftComparison: string;
  primaryRespondentScore: number;
  rightComparison: string;
  secondaryRespondentName?: string;
  secondaryRespondentScore?: number;
  compatibilityScore?: number;
}

export const CategoryScore = ({
  leftComparison,
  primaryRespondentScore,
  rightComparison,
  secondaryRespondentName,
  secondaryRespondentScore,
  compatibilityScore,
  ...rest
}: CategoryScoreProps) => {
  return (
    <Box {...rest}>
      <Box position="relative" pt="24" pb={secondaryRespondentName ? '24' : '0'}>
        <Legend direction="pointDown" percentage={primaryRespondentScore}>
          You
        </Legend>

        <Chart size="medium" score={compatibilityScore}>
          <Text
            color={compatibilityScore === undefined ? 'white' : 'neutral.700'}
            fontWeight={600}
            fontSize="small"
          >
            {leftComparison}
          </Text>

          <Text
            color={compatibilityScore === undefined ? 'white' : 'neutral.700'}
            fontWeight={600}
            fontSize="small"
          >
            {rightComparison}
          </Text>
        </Chart>

        {secondaryRespondentName && secondaryRespondentScore !== undefined && (
          <Legend direction="pointUp" percentage={secondaryRespondentScore} placement="bottom">
            {secondaryRespondentName}
          </Legend>
        )}
      </Box>
    </Box>
  );
};
